<template>
  <div class="mainBox">
    <div class="mainContent">
      <div class="banner">
        <img width="100%" src="https://admin.rabbitchop.com/upload/oto/OnlineBanner_OTO_Dec22_v3_1508%20x%20662.jpg" alt="">
      </div>
      <div class="selectedCouponBox">
        <div class="selectedCouponBox_title">OTO x 頭條日報 精選優惠</div>
        <div class="titleUnderline"></div>
        <div class="SelectedCouponContent row">
          <div
            class="selected_couponBigEventContent col-12 col-sm-6 col-md-6 col-lg-4"
            v-for="item in selectedCouponsList"
            :key="item.id"
            @click="goCouponDetail(item.couponId)"
          >
            <div class="small_couponEventContent">
              <div class="panel-body">
                <div class="row">
                  <div
                    class="small_couponEventContent_img col-4 col-sm-5"
                    ref="imgBox"
                  >
                    <div class="img-wrapper">
                      <img
                        :src="item.detailBannerUrl"
                        alt
                      />
                    </div>
                  </div>
                  <div class="small_content_right col-8 col-sm-7">
                    <div class="small_content_right_img">
                      <span>{{ item.shortDescription }}</span>
                    </div>
                    <ul>
                      <li
                        v-if="item.couponType === 'Percentage Off'"
                        class="small_per_symbol"
                      >
                        <span class="newWeek_percentage">{{
                          parseFloat(parseFloat(item.amount).toFixed(2))
                        }}</span>
                        {{ item.symbol }}
                      </li>
                      <li
                        v-if="item.couponType === 'Fixed Amount'"
                        class="small_per_symbol"
                      >
                        {{ item.symbol }}
                        <span class="newWeek_percentage">{{
                          parseFloat(parseFloat(item.amount).toFixed(2))
                        }}</span>
                      </li>
                      <li
                        v-if="item.couponType === 'Amount Off'"
                        class="small_per_symbol"
                      >
                        {{ item.symbol }}
                        <span class="newWeek_percentage">{{
                          parseFloat(parseFloat(item.amount).toFixed(2))
                        }}</span>
                        off
                      </li>
                      <li class="small_validityDate">
                        {{ item.effectiveStartDate }} -
                        {{ item.effectiveEndDate }}
                      </li>
                    </ul>
                    <div class="verbar">
                      <template v-if="Number(item.price) === 0">
                        <div class="small_redeem_button">
                          <i class="icon">
                            <img src="@/assets/images/icon-heart.svg" />
                          </i>
                          Download
                        </div>
                      </template>
                      <template v-else>
                        <div
                          class="small_redeem_button price_button"
                          @click.stop="addCart(item)"
                        >
                          <i class="icon iconfont icon-shopping"></i>
                          購買 ${{ parseFloat(item.price).toFixed(2) }}
                        </div>
                      </template>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapMutations } from 'vuex'
import { getCoupons } from '@/api/coupon'

export default {
  data () {
    return {
      selectedCouponsList: []
    }
  },
  mounted () {
    getCoupons({
      pageNo: 1,
      pageSize: 0,
      customizationKey: 'oto'
    }).then((res) => {
      this.selectedCouponsList = res.list
      this.$emit('getMerchantName', this.selectedCouponsList[0].merchantName)
    })
  },
  methods: {
    ...mapMutations('cart', [
      'addCart'
    ]),

    goCouponDetail: function (params) {
      const couid = params
      this.$router.push({
        path: `/coupon/oto/${couid}`
      })
    }
  }
}

</script>

<style scoped>
.mainBox {
  background: #fafafa;
}

.mainContent {
  text-align: left;
  max-width: 1280px;
  padding: 0 15px;
  margin: 0 auto;
}

.mainContent_firstTitle {
  color: #666666;
}

.mainContent_lastTitle {
  color: #0f96bb;
}

.titleUnderline {
  width: 50px;
  background: #ffbf00;
  border-radius: 3px;
  height: 5px;
  margin-top: 10px;
}

.titleUnderline::after {
  content: "";
  display: block;
  width: 5px;
  background: #ffbf00;
  border-radius: 3px;
  height: 5px;
  margin-top: 10px;
  margin-left: 60px;
}

.selectedCouponBox {
  margin-top: 40px;
  position: relative;
  text-align: left;
  padding-bottom: 70px;
}

.selectedCouponBox_title {
  font-style: normal;
  font-weight: bold;
  font-size: 24px;
  color: #0f96bb;
}

.SelectedCouponContent {
  margin-top: 30px;
}

.SelectedCouponContent:after {
  content: "";
  display: block;
  clear: both;
}

@media (max-width: 1000px) and (min-width: 0px) {
  .verbar {
    padding-bottom: 1.8rem;
  }

  .selectedCouponBox {
    padding-bottom: 20px;
  }
}

@media (min-width: 768px) and (max-width: 1280px) {

  .selectedCouponBox {
    padding: 0 15px;
  }
}

.small_content_right_img span {
  display: inline-block;
}
</style>
